// Generated by purs version 0.13.8
"use strict";
var React_Basic_Native_Styles = require("../React.Basic.Native.Styles/index.js");
var ZAP_Dart_Client_Constants = require("../ZAP.Dart.Client.Constants/index.js");
var screenMaxWidth = React_Basic_Native_Styles.maxWidth(React_Basic_Native_Styles.intMaxWidth)(ZAP_Dart_Client_Constants.maxScreenWidth);
module.exports = {
    screenMaxWidth: screenMaxWidth
};
